import { Col, Row } from 'antd';
import styled from 'styled-components';
import {
  maxWidth, retina,
  primaryHeadingColor, secondaryFont, wMBold, boxShadow, scrollbar,
} from 'Utils/utilsStyle';

import ChartSpinner from '../ChartSpinner';
import EngagementProfile from '../EngagementProfile';
import EngagementTitle from '../EngagementTitle';
import EngagementSalesTrigger from '../EngagementSalesTrigger';

const Wrapper = styled.div`
  .title {
    font-size: 25px;
    font-weight: ${wMBold};
    letter-spacing: -0.7px;
    font-family: ${secondaryFont};
    color: ${primaryHeadingColor};
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 22px;
    }
  }
  .tabs-item {
    cursor: pointer;
  }
  .no-data-holder {
    font-size: 20px;
    height: 250px;
    width: 100%;
    margin: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: ${wMBold};
    letter-spacing: -0.7px;
    font-family: ${secondaryFont};
    color: ${primaryHeadingColor};
  }
`;

const ScoreBreakDown = styled.div`
  padding: 24px 42px;
  box-shadow: ${boxShadow};
  border-radius: 16px;
  background: #fff;
  margin-bottom: 40px;
  .highcharts-background {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

const Engagement = styled.div`
 .ant-col {
   margin-bottom: 45px;
 }
`;

const Scrollbar = styled.div<{ withoutBackground?: boolean }>`
  margin: 0px 5px 0 0px;
  padding-right: 10px;
  background: ${(props) => (props.withoutBackground ? '#fff' : '')};
  max-height: 540px;
  ${scrollbar};
`;

const OverViewTabSkeleton = function OverViewTabSkeleton() {
  return (
    <Wrapper>
      <ScoreBreakDown>
        <Row>
          <ChartSpinner />
        </Row>
      </ScoreBreakDown>
      <Engagement>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <EngagementTitle primaryHeading="Company" secondaryHeading="Views" />
            <Scrollbar>
              {Array.from(Array(6)).map(() => <EngagementProfile loading />)}
            </Scrollbar>
          </Col>
          <Col span={8}>
            <EngagementTitle primaryHeading="Sales Triggers" secondaryHeading="Articles" />
            <Scrollbar withoutBackground>
              {[1, 2, 3, 4, 5, 6].map(
                () => <EngagementSalesTrigger loading />,
              )}
            </Scrollbar>
          </Col>
        </Row>
      </Engagement>
    </Wrapper>
  );
};

export default OverViewTabSkeleton;
